import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import MdlSidebarOverlay from "../Sidebar/MdlSidebarOverlay";
import axios from 'axios';
import { Box, Paper, Typography, Button, Divider, IconButton } from '@mui/material';

import MdlSettingEditAccount from "./MdlSettingEditAccount"; 
import MdlSettingCreateAccount from "./MdlSettingCreateAccount"; 


export default function SettingUserMgntCard({ createUser, editUser, props }) {
  const { t } = useTranslation();
	
  const [users, setUsers] = useState([]);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const loadUsers = () => {
    axios.get('/users')
      .then(res => {
        if (res.data) setUsers(res.data);
      })
      .catch(err => console.error("Fehler beim Laden:", err));
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setOpenEditModal(true);
  };

  const handleDeleteUser = (id) => {
    if (window.confirm(t("SettingUserMgntCard.delete_user"))) {
      axios.delete(`/users/${id}`)
        .then(() => loadUsers())
        .catch(err => console.error("Fehler beim Löschen:", err));
    }
  };

  return (
    <div className="doc_box" style={{ width: "100%", maxWidth: "800px", margin: "0 auto", padding: "20px", backgroundColor: "white" }}>
      
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6" style={{ fontWeight: "bold", color: "#1d1b31" }}>
			{t("SettingUserMgntCard.pageTitle")}
        </Typography>
        <Button 
          variant="contained" 
          startIcon={<PersonAddIcon />}
          onClick={() => setOpenCreateModal(true)}
          sx={{ backgroundColor: "#4f40b3", borderRadius: "8px", textTransform: "none", '&:hover': { backgroundColor: '#3b2f93' } }}
        >
          {t("SettingUserMgntCard.create_user")}
        </Button>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Box style={{ display: "flex", flexDirection: "column", gap: "12px", maxHeight: "400px", overflowY: "auto", paddingRight: "4px" }}>
        {users.length > 0 ? (
          users.map((user) => (
            <Paper 
              key={user.id} 
              variant="outlined" 
              sx={{ 
                p: "14px 20px", 
                borderRadius: "10px", 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center",
                backgroundColor: user.is_active === false ? "#f9f9f9" : "white",
                borderColor: user.is_active === false ? "#e0e0e0" : "#ececec"
              }}
            >
              <Box style={{ textAlign: "left" }}>
                <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <Typography style={{ fontWeight: 600, color: "#1d1b31", fontSize: "15px" }}>
                    {user.username || t("SettingUserMgntCard.missing_user")}
                  </Typography>
                  {user.first_name && (
                    <Typography variant="body2" color="textSecondary">
                      ({user.first_name} {user.last_name})
                    </Typography>
                  )}
                  {user.is_active === false && (
                    <span style={{ fontSize: "11px", backgroundColor: "rgba(255,0,0,0.08)", color: "tomato", padding: "2px 8px", borderRadius: "6px", fontWeight: "bold" }}>
                      DEAKTIVIERT
                    </span>
                  )}
                </Box>
                
                <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: "4px" }}>
                  {t("user.mails")}: <b>{user.email}</b> | {t("user.role")}: {user.role === 0 ? t("user.role_admin") : t("user.role_user")} | {t("user.language")}: {user.language?.toUpperCase()}
                </Typography>
              </Box>

              <Box style={{ display: "flex", gap: "5px" }}>
                <IconButton onClick={() => handleEditClick(user)} sx={{ color: "#4f40b3" }} aria-label={t("common.edit")}>
                  <EditIcon size="small" />
                </IconButton>

                {/* Löschen (Admin ID 1 geschützt) */}
                {user.id !== 1 && (
                  <IconButton onClick={() => handleDeleteUser(user.id)} sx={{ color: "tomato" }} aria-label={t("common.delete")}>
                    <DeleteIcon size="small" />
                  </IconButton>
                )}
              </Box>
            </Paper>
          ))
        ) : (
		<Typography variant="body2" style={{ fontStyle: "italic", color: "gray", padding: "10px" }}>{t("SettingUserMgntCard.load_users")}...</Typography>
        )}
      </Box>

      <MdlSidebarOverlay title={t("SettingUserMgntCard.create_user")} onClose={() => setOpenCreateModal(false)} show={openCreateModal}>
        <MdlSettingCreateAccount 
		   onClose={() => setOpenCreateModal(false)} 
		   getUsersData={loadUsers} 
		   createUser={createUser} 
		   onRefresh={loadUsers}
		/>
      </MdlSidebarOverlay>

	  <MdlSidebarOverlay title={t("SettingUserMgntCard.edit_user")} onClose={() => setOpenEditModal(false)} show={openEditModal}>
        {selectedUser && (
          <MdlSettingEditAccount 
            user={selectedUser} 
            onClose={() => setOpenEditModal(false)} 
            onRefresh={loadUsers} 
			editUser={editUser}
          />
        )}
      </MdlSidebarOverlay>

    </div>
  );
}
